import React from "react";
import { createGlobalStyle } from "styled-components";
import { useEffect } from "react";
import axios from "axios";
import { apiCall_domain } from "../api";
import { useState } from "react";
import Spinner from "../Spinner/Spinner";
import Header from "../header";
import { Link } from "react-router-dom";

import MyCar from "./MyCar";

const MyCars = () => {
  const [state, setState] = useState({
    myCars: [],
    loading: true,
  });
  const GlobalStyles = createGlobalStyle`body{
        background: #fafafa !important;
        position: relative;
    }`;
  const headers = {
    Authorization: localStorage.getItem("Api_key"),
    "content-type": "application/json",
  };

  const getCars = () => {
    setState({ ...state, loading: true });
    axios
      .get(`${apiCall_domain}/customer/user/cars`, { headers: headers })
      .then((res) => setState({ myCars: res.data.data, loading: false }));
  };

  useEffect(() => {
    getCars();
  }, []);
  return (
    <>
      {state.loading ? (
        <Spinner />
      ) : (
        <>
          <GlobalStyles />
          <Header
            showSearchBar={true}
            backUrl={"/profile"}
            title="خودرو های من"
          />
          <div className="MyCars">
            {state.loading ? (
              <Spinner />
            ) : state.myCars.length ? (
              state.myCars.map((car, index) => (
                <MyCar car={car} getCars={getCars} key={index} />
              ))
            ) : (
              <div className="empty">هیج ماشینی شما ثبت نکرده اید</div>
            )}
          </div>
          <div className="addCarButtonSection">
            <Link to="/profile/addCar">
              <button className={`btn btn--cusaddcar`}>افزودن خودرو</button>
            </Link>
          </div>
        </>
      )}
    </>
  );
};
export default MyCars;
